import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-trend-card',
  templateUrl: './trend-card.component.html',
  styleUrls: ['./trend-card.component.scss']
})
export class TrendCardComponent implements OnInit {
  @Input('data') public trend;
  @Input('key') public key: string;
  @Input('type') public type: 'stock' | 'crypto';
  @Output('trendClick') trendClick = new EventEmitter(null);
  constructor() { }

  ngOnInit(): void {
    switch (this.key) {
      case 'reddit':
        this.trend['class'] = 'reddit';
        this.trend['title'] = 'Reddit';
        this.trend['tooltip'] = 'Top 20 by mentions past 24 hours';
        break;
      case 'searchEngine':
        this.trend['class'] = 'search-engine';
        this.trend['title'] = 'Search Engine';
        this.trend['tooltip'] = 'Top 20 increased percentage search volume past 24 hours';
        break;
      case 'stocktwits':
        this.trend['class'] = 'stocktwits';
        this.trend['title'] = 'Stocktwits';
        this.trend['tooltip'] = 'Top 20 by posts past 24 hours';
        break;
      case 'twitter':
        this.trend['class'] = 'twitter';
        this.trend['title'] = 'Twitter';
        this.trend['tooltip'] = 'Top 20 by posts past 24 hours';
    }
  }

  roundOf(value){
    return Math.round(value)
  }


  openModal(row) {
    this.trendClick.emit(row);
  }

}
